import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class ReasonsService {
    private reasonsUrl = 'assets/reasons.json';

    constructor(private http: HttpClient) {}

    getReasons(): Observable<any[]> {
        return this.http.get<any[]>(this.reasonsUrl);
    }

    saveReasons(reasons: any[]): void {
        localStorage.setItem('reasons', JSON.stringify(reasons));
    }

    getLocalReasons(): any[] {
        const reasons = localStorage.getItem('reasons');
        return reasons ? JSON.parse(reasons) : [];
    }
}